import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { Observable, from, of, throwError } from 'rxjs';
import { CustomShareData } from '../models';

@Injectable({
  providedIn: 'root',
})
export class BrowserNavigatorService {
  constructor(public windowRef: WindowRef) {}

  nativeShare(data: CustomShareData): Observable<unknown> {
    try {
      // чтобы не было illegal invocation
      const shareFn = (shareData: CustomShareData): Promise<void> => {
        if (!this.windowRef || !this.windowRef.nativeWindow || !this.windowRef.nativeWindow.navigator) {
          throw new Error('window or navigator is not defined');
        }

        return this.windowRef.nativeWindow.navigator.mobileShareText
          ? this.windowRef.nativeWindow.navigator.mobileShareText(shareData)
          : this.windowRef.nativeWindow.navigator.share(shareData);
      };

      const promise = shareFn(data);

      if (typeof promise !== 'undefined') {
        return from(promise.catch(this.handleShareError));
      } else {
        // в аппе(webview) вызов mobileShareText передаёт аргументы своему хэндлеру, который возвращает undefined
        // т.е. без доработок в аппе со своей стороны успешность выполнения мы понять не можем
        return of(true);
      }
    } catch (err) {
      return throwError(() => err);
    }
  }

  handleShareError(err: { code: number }): void {
    // TODO: Протестировать в браузере
    if (err instanceof DOMException && err.name === 'AbortError') {
      return;
    }
    throw err;
  }

  copyToClipboard(text: string): Observable<void> {
    try {
      if (!this.windowRef.nativeWindow) {
        throw new Error();
      }

      return from(this.windowRef.nativeWindow.navigator.clipboard.writeText(text));
    } catch (err) {
      return throwError(() => err);
    }
  }
}
